module.exports = __webpack_public_path__ + "img/15.264fc046.jpg";